(() => {
  const formatTime = (seconds) => {
    if (!Number.isFinite(seconds)) return '0:00';
    const s = Math.floor(seconds);
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
  };

  // [tid] -> time left until midnight ("5 tim 27 min"), when the [start]/[slut] dates move one day on.
  const untilMidnight = () => {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    const minutes = Math.max(1, Math.ceil((midnight - now) / 60000));
    const h = Math.floor(minutes / 60);
    return h ? `${h} tim ${minutes % 60} min` : `${minutes} min`;
  };

  // Delivery estimate: [start] / [slut] -> today + min/max days (or Mon–Fri working days), Swedish short date.
  document.querySelectorAll('[data-hp-delivery]').forEach((el) => {
    const template = el.dataset.template || '';
    const workingDays = el.hasAttribute('data-working-days');
    const add = (days) => {
      const d = new Date();
      if (workingDays) {
        for (let left = Number(days || 0); left > 0; ) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1;
        }
      } else {
        d.setDate(d.getDate() + Number(days || 0));
      }
      return new Intl.DateTimeFormat('sv-SE', { day: 'numeric', month: 'short' }).format(d);
    };
    const escape = (s) => s.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
    el.innerHTML = escape(template)
      .replace('[tid]', `<strong>${untilMidnight()}</strong>`)
      .replace('[start]', `<strong>${add(el.dataset.minDays)}</strong>`)
      .replace('[slut]', `<strong>${add(el.dataset.maxDays)}</strong>`);
  });

  // CODE-DESIGN-16: Teeinblue-formuläret renderas efteråt; de här ändringarna görs när det finns och körs om vid omritning.
  const deliveryDefaults = new Map();
  const renderDelivery = (el, min, max) => {
    const template = el.dataset.template || '';
    const workingDays = el.hasAttribute('data-working-days');
    const add = (days) => {
      const d = new Date();
      if (workingDays) {
        for (let left = Number(days || 0); left > 0; ) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1;
        }
      } else {
        d.setDate(d.getDate() + Number(days || 0));
      }
      return new Intl.DateTimeFormat('sv-SE', { day: 'numeric', month: 'short' }).format(d);
    };
    const escape = (s) => s.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
    el.innerHTML = escape(template)
      .replace('[tid]', `<strong>${untilMidnight()}</strong>`)
      .replace('[start]', `<strong>${add(min)}</strong>`)
      .replace('[slut]', `<strong>${add(max)}</strong>`);
  };
  // Keep the countdown (and the dates after midnight) current.
  setInterval(() => {
    document.querySelectorAll('[data-hp-delivery]').forEach((el) => {
      if (!(el.dataset.template || '').includes('[tid]')) return;
      const [min, max] = (el.dataset.hpMode || `${el.dataset.minDays},${el.dataset.maxDays}`).split(',');
      renderDelivery(el, min, max);
    });
  }, 60000);
  const enhanceForm = () => {
    const form = document.querySelector('#teeFormInputs');
    if (!form) return;
    // 1. Etikett för skärmläsare: fält utan <label for> får aria-label från rubriken.
    form.querySelectorAll('.tee-field').forEach((field) => {
      const heading = field.querySelector('.tee-field__heading');
      if (!heading) return;
      const name = heading.textContent.replace('*', '').replace(/\s+/g, ' ').trim();
      field.querySelectorAll('input:not([type=radio]):not([type=checkbox]):not([type=hidden]), textarea, select').forEach((input) => {
        if (!input.getAttribute('aria-label') && !(input.labels && input.labels.length)) input.setAttribute('aria-label', name);
      });
    });
    // 2. Radioval: appen markerar bara med klassen .active – spegla i checked för skärmläsare.
    form.querySelectorAll('.tee-radio > input[type=radio]').forEach((input) => {
      const active = input.parentElement.classList.contains('active');
      if (input.checked !== active) input.checked = active;
    });
    // 3. Dubbelt tillvalspris ("+99 kr +99 SEK"): appen lägger sitt pris efter etikettens eget.
    form.querySelectorAll('.tee-radio-label span').forEach((span) => {
      const fixed = span.textContent.replace(/\+\s?(\d[\d\s]*?)\s*kr\s+\+\s?\1\s*(SEK|kr)/i, '+$1 kr').replace(/\s{2,}/g, ' ');
      if (fixed !== span.textContent) span.textContent = fixed;
    });
    // 4. Leveransdatumet följer Express (klar inom 12 timmar: i dag–i morgon).
    const express = [...form.querySelectorAll('.tee-radio.active')].some((r) => /express/i.test(r.textContent));
    document.querySelectorAll('[data-hp-delivery]').forEach((el) => {
      if (!deliveryDefaults.has(el)) deliveryDefaults.set(el, [el.dataset.minDays, el.dataset.maxDays]);
      const [min, max] = deliveryDefaults.get(el);
      const wanted = express ? '0,1' : `${min},${max}`;
      if (el.dataset.hpMode !== wanted) {
        el.dataset.hpMode = wanted;
        renderDelivery(el, ...(express ? [0, 1] : [min, max]));
      }
    });
    // 5. Teeinblues huvudbild saknar alt-text.
    const title = document.querySelector('.product__title h1');
    document.querySelectorAll('#tee-gallery img[alt=""]:not(.tee-image--loader)').forEach((img) => {
      if (title && img.getBoundingClientRect().width > 100) img.setAttribute('alt', `${title.textContent.trim()} – exempel på mockup`);
    });
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    setTimeout(() => {
      pending = false;
      enhanceForm();
    }, 80);
  };
  enhanceForm();
  if ('MutationObserver' in window) {
    const root = document.querySelector('product-info') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('change', (event) => {
    if (event.target.closest('#teeFormInputs')) schedule();
  });

  // Audio samples: one plays at a time.
  const players = [...document.querySelectorAll('[data-hp-audio]')];
  players.forEach((item) => {
    const audio = item.querySelector('audio');
    const button = item.querySelector('.hp-audio__play');
    const wave = item.querySelector('.hp-audio__wave');
    const time = item.querySelector('.hp-audio__time');

    const render = () => {
      const pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
      wave.style.setProperty('--hp-progress', `${pct}%`);
      wave.setAttribute('aria-valuenow', String(Math.round(pct)));
      wave.setAttribute('aria-valuetext', formatTime(audio.currentTime));
      time.textContent = `${formatTime(audio.currentTime)} / ${formatTime(audio.duration)}`;
    };
    const setPlaying = (playing) => {
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', playing ? button.dataset.labelPause : button.dataset.labelPlay);
    };
    const seekTo = (ratio) => {
      if (!audio.duration) return;
      audio.currentTime = Math.min(Math.max(ratio, 0), 1) * audio.duration;
      render();
    };

    button.setAttribute('aria-pressed', 'false');
    button.addEventListener('click', () => {
      if (audio.paused) {
        players.forEach((other) => other !== item && other.querySelector('audio').pause());
        audio.play();
      } else {
        audio.pause();
      }
    });
    audio.addEventListener('play', () => setPlaying(true));
    audio.addEventListener('pause', () => setPlaying(false));
    audio.addEventListener('ended', () => setPlaying(false));
    audio.addEventListener('loadedmetadata', render);
    audio.addEventListener('timeupdate', render);

    // "Hör namnet vid 0:12": play from there. With preload="none" the time can only be set once metadata has loaded.
    const jump = item.querySelector('[data-hp-audio-jump]');
    if (jump) {
      const [m, s] = jump.dataset.hpAudioJump.split(':').map(Number);
      const at = (m || 0) * 60 + (s || 0);
      jump.addEventListener('click', () => {
        players.forEach((other) => other !== item && other.querySelector('audio').pause());
        if (audio.readyState >= 1) {
          audio.currentTime = at;
        } else {
          audio.addEventListener('loadedmetadata', () => (audio.currentTime = at), { once: true });
          audio.load();
        }
        audio.play();
      });
    }

    wave.addEventListener('click', (event) => {
      const rect = wave.getBoundingClientRect();
      seekTo((event.clientX - rect.left) / rect.width);
    });
    wave.addEventListener('keydown', (event) => {
      if (!audio.duration) return;
      const step = { ArrowRight: 5, ArrowUp: 5, ArrowLeft: -5, ArrowDown: -5 }[event.key];
      if (step !== undefined) {
        event.preventDefault();
        seekTo((audio.currentTime + step) / audio.duration);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        seekTo(event.key === 'Home' ? 0 : 1);
      }
    });
  });
})();

// Buy bars: our desktop bar (snippets/hp-sticky-cta.liquid, shown while the personalisation form and buy button are
// out of view) and Teeinblue's mobile sticky button. Both show the price with the ticked add-ons and the struck-through
// price. A tap scrolls to the first empty required field, or adds to the cart through the real buy button when the
// form is filled; the cart drawer then opens right away. Teeinblue's own button only scrolls to the form.
(() => {
  const form = document.querySelector('product-form') || document.querySelector('.product-form');
  if (!form) return;
  const bar = document.querySelector('[data-hp-sticky-cta]');
  const info = document.querySelector('.product__info-container');
  const og = parseInt(document.querySelector('meta[property="og:price:amount"]')?.content || '', 10);
  const base = Number(bar?.dataset.hpPrice) || og;
  const compare = Number(bar?.dataset.hpCompare) || 0;
  const words = document.querySelector('.hp-scope--song')
    ? 'Skapa er låt'
    : document.querySelector('.hp-scope--pappa')
      ? 'Skapa pappas låt'
      : 'Gör den personlig';
  const submitButton = () => form.querySelector('.product-form__submit');
  // The buy button carries the total with the ticked add-ons ("Lägg i varukorgen · 628 kr", see compactAddons).
  const total = () => {
    const match = (submitButton()?.textContent || '').match(/·\s*([\d\s]+)\s*kr/);
    return (match && parseInt(match[1].replace(/\s/g, ''), 10)) || base;
  };

  // Teeinblue placeholders are disabled options with the value "null"; fields labelled "valfritt" are optional.
  // Radio and checkbox groups are choices with a working default (map style, stand, voice), so they are never "empty".
  const isEmpty = (field) => {
    if (field.type === 'radio' || field.type === 'checkbox') return false;
    if (field.tagName === 'SELECT') {
      const option = field.options[field.selectedIndex];
      return !option || option.disabled || !field.value || field.value === 'null';
    }
    return !String(field.value || '').trim();
  };
  const isOptional = (field) => {
    let el = field;
    for (let i = 0; i < 4 && el.parentElement; i += 1) {
      el = el.parentElement;
      const label = el.querySelector('label');
      if (label) return /valfri/i.test(label.textContent);
    }
    return false;
  };

  let busyUntil = 0;
  const go = () => {
    const fields = [...form.querySelectorAll('#teeFormInputs input, #teeFormInputs textarea, #teeFormInputs select')].filter(
      (f) => f.type !== 'hidden' && f.offsetParent !== null && !f.disabled
    );
    const empty = fields.find((f) => isEmpty(f) && !isOptional(f));
    const submit = submitButton();
    if (empty || !submit || submit.disabled) {
      const target = empty || submit || form;
      // Instant: a smooth scroll is sometimes dropped on the heart page and the tap then seems to do nothing.
      target.scrollIntoView({ block: 'center' });
      setTimeout(() => target.focus({ preventScroll: true }), 450);
      return;
    }
    // Teeinblue validates and saves the design on the buy button's click; errors show next to the form.
    busyUntil = Date.now() + 8000;
    paint();
    submit.scrollIntoView({ block: 'center' });
    submit.click();
    // A field Teeinblue rejects is marked tee-field--invalid: show it instead of waiting.
    setTimeout(() => {
      const invalid = document.querySelector('#teeFormInputs .tee-field--invalid, #teeFormInputs .tee-error');
      if (!invalid) return;
      busyUntil = 0;
      paint();
      invalid.scrollIntoView({ block: 'center' });
    }, 700);
    setTimeout(paint, 8100);
  };

  const kr = (n) => `${n} kr`;
  const paint = () => {
    const now = total();
    const was = compare > base ? compare + now - base : 0;
    const busy = Date.now() < busyUntil;
    if (bar) {
      const amount = bar.querySelector('[data-hp-sticky-cta-amount]');
      const struck = bar.querySelector('[data-hp-sticky-cta-compare]');
      const button = bar.querySelector('[data-hp-sticky-cta-go]');
      if (amount && amount.textContent.trim() !== kr(now)) amount.textContent = kr(now);
      if (struck && was && struck.textContent.trim() !== kr(was)) struck.textContent = kr(was);
      if (button) button.disabled = busy;
    }
    // Teeinblue re-renders its button, so the label is re-applied whenever it changes.
    const label = busy ? 'Lägger i varukorgen …' : `${words} · ${was ? `${kr(was)} ` : ''}${kr(now)}`;
    document.querySelectorAll('.tee-btn-wrapper--personalize .tee-btn').forEach((button) => {
      if (button.textContent.trim() === label) return;
      button.innerHTML = busy || !was ? '' : `${words} · <s class="hp-tee-compare"></s> `;
      if (busy || !was) button.textContent = label;
      else {
        button.querySelector('s').textContent = kr(was);
        button.append(kr(now));
      }
    });
  };
  new MutationObserver(paint).observe(document.body, { childList: true, subtree: true, characterData: true });
  paint();

  // Capture phase, so Teeinblue's own handler (scroll to the form) never runs.
  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('.tee-btn-wrapper--personalize .tee-btn')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (Date.now() >= busyUntil) go();
    },
    true
  );

  // Teeinblue waits 1 s after saving the design before it adds to the cart (customization_delay, 0 means the default).
  window.teeinblue = Object.assign(window.teeinblue || {}, { customization_delay: 1 });
  // Teeinblue adds to the cart itself, so Dawn's drawer would not open: open it as soon as the cart has the song.
  document.addEventListener('teeinblue-event-after-cart-added', () => {
    busyUntil = 0;
    paint();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    const ids = drawer.getSectionsToRender().map((section) => section.id);
    fetch(`${window.routes?.cart_url || '/cart'}?sections=${ids.join(',')}`)
      .then((response) => response.json())
      .then((sections) => drawer.renderContents({ sections }))
      .catch(() => {});
  });

  if (!bar || !info || !('IntersectionObserver' in window)) return;
  document.body.appendChild(bar);
  let formVisible = true;
  let pastTop = false;
  // Only on personalised products: add-ons (stand, bag) share the template but have no Teeinblue form.
  const update = () => {
    bar.hidden = formVisible || !pastTop || !form.querySelector('#teeFormInputs');
  };
  new IntersectionObserver((entries) => {
    formVisible = entries.some((entry) => entry.isIntersecting);
    update();
  }).observe(form);
  const onScroll = () => {
    pastTop = window.scrollY > info.getBoundingClientRect().top + window.scrollY + 120;
    update();
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  bar.querySelector('[data-hp-sticky-cta-go]').addEventListener('click', go);
})();

// Form preset (block hp_form_preset, on the song templates): once the Teeinblue form has rendered, preselect dropdown
// options (only if nothing is chosen yet) and swap the placeholders of the first two text fields and the first text
// area. select_option is looked up in every dropdown; each line "Field heading: Option" of select_fields only in the
// dropdown of the field whose heading starts that way (needed for "Överraska mig", which is in two dropdowns).
// Teeinblue renders fields in steps and may re-render them, so placeholders are re-applied for a few seconds and
// whenever Teeinblue changes them back.
(() => {
  const preset = document.querySelector('[data-hp-form-preset]');
  if (!preset) return;
  const wanted = (preset.dataset.select || '').trim().toLowerCase();
  let selectDone = !wanted;
  // Option texts may start with an emoji ("🎉 Fars dag"), so compare from the first letter or digit.
  const optionText = (o) => o.text.replace(/^[^\p{L}\p{N}]+/u, '').trim().toLowerCase();
  const fieldPresets = (preset.dataset.selectFields || '')
    .split('\n')
    .map((line) => line.split(':'))
    .filter((parts) => parts.length === 2 && parts[0].trim() && parts[1].trim())
    .map(([field, option]) => ({ field: field.trim().toLowerCase(), option: option.trim().toLowerCase(), done: false }));
  const pick = (select, option) => {
    if (select.value && select.value !== 'null') return;
    const match = [...select.options].find((o) => optionText(o) === option);
    if (!match) return;
    select.value = match.value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const chooseFields = () => {
    const form = document.querySelector('#teeFormInputs');
    if (!form) return;
    fieldPresets
      .filter((entry) => !entry.done)
      .forEach((entry) => {
        const field = [...form.querySelectorAll('.tee-field')].find((f) =>
          (f.querySelector('.tee-field__heading')?.textContent || '').replace('*', '').trim().toLowerCase().startsWith(entry.field)
        );
        const select = field && field.querySelector('select');
        if (!select) return;
        entry.done = true;
        pick(select, entry.option);
      });
  };
  const placeholders = () => {
    const form = document.querySelector('#teeFormInputs');
    if (!form) return;
    const texts = [...form.querySelectorAll('input[type="text"]')].filter((f) => f.offsetParent !== null);
    const area = [...form.querySelectorAll('textarea')].find((f) => f.offsetParent !== null);
    [[texts[0], preset.dataset.placeholderFirst], [texts[1], preset.dataset.placeholderSecond], [area, preset.dataset.placeholderArea]].forEach(
      ([field, text]) => {
        if (field && text && field.placeholder !== text) field.placeholder = text;
      }
    );
    const hint = area && area.closest('.tee-field')?.querySelector('.tee-input-hint');
    if (hint && preset.dataset.hintArea && hint.textContent !== preset.dataset.hintArea) hint.textContent = preset.dataset.hintArea;
  };
  const choose = () => {
    const form = document.querySelector('#teeFormInputs');
    if (!form) return;
    const select = [...form.querySelectorAll('select')].find((s) => [...s.options].some((o) => optionText(o) === wanted));
    if (!select) return;
    selectDone = true;
    pick(select, wanted);
  };
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (!selectDone) choose();
    chooseFields();
    placeholders();
    if (tries > 60) clearInterval(timer);
  }, 250);
  const root = document.querySelector('product-info') || document.body;
  new MutationObserver(placeholders).observe(root, { subtree: true, attributes: true, attributeFilter: ['placeholder'], childList: true, characterData: true });
})();

// Story questions (block hp_story_guide, song templates): tappable questions above the story text area. A tap adds the
// question's sentence start on a new line of Teeinblue's own field and puts the cursor after it, so the order still has
// one story property. The choice fields from the first add-on field onwards get a shared card with a title.
(() => {
  const guide = document.querySelector('[data-hp-story-guide]');
  if (!guide) return;
  const chips = [...guide.querySelectorAll('[data-hp-story-chip]')].map((chip) => ({
    label: chip.dataset.label,
    text: chip.dataset.text.trim(),
  }));
  const heading = (field) =>
    (field.querySelector('.tee-field__heading')?.textContent || '').replace('*', '').replace(/\s+/g, ' ').trim().toLowerCase();
  const storyHeading = (guide.dataset.field || '').trim().toLowerCase();
  const addonsHeading = (guide.dataset.addonsFirst || '').trim().toLowerCase();
  const setValue = (area, value) => {
    Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(area, value);
    area.dispatchEvent(new Event('input', { bubbles: true }));
  };
  const addChips = (story) => {
    if (!chips.length || story.querySelector('.hp-story-guide')) return;
    const input = story.querySelector('.tee-field__input');
    if (!input) return;
    const box = document.createElement('div');
    box.className = 'hp-story-guide';
    if (guide.dataset.intro) {
      const intro = document.createElement('p');
      intro.className = 'hp-story-guide__intro';
      intro.textContent = guide.dataset.intro;
      box.append(intro);
    }
    const list = document.createElement('div');
    list.className = 'hp-story-guide__chips';
    chips.forEach((chip) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'hp-story-guide__chip';
      button.textContent = chip.label;
      button.addEventListener('click', () => {
        const area = story.querySelector('textarea');
        if (!area) return;
        const current = area.value.replace(/\s+$/, '');
        const next = `${current ? `${current}\n` : ''}${chip.text} `;
        if (area.maxLength > 0 && next.length > area.maxLength) return;
        setValue(area, next);
        button.classList.add('is-used');
        area.focus();
        area.setSelectionRange(next.length, next.length);
      });
      list.append(button);
    });
    box.append(list);
    input.before(box);
  };
  const leadHeading = (guide.dataset.addonsLead || '').trim().toLowerCase();
  const radioOn = (radio) => radio.checked || radio.closest('.tee-radio')?.classList.contains('active');
  // Compact add-ons (setting addons_compact): when every add-on field is a pair "no / yes", Teeinblue's fields stay in
  // the form but are hidden, and the first one shows a checkbox row per add-on instead. A row clicks Teeinblue's own
  // yes or no radio, so the order still carries the same properties. addons_lead puts one add-on first in the list.
  const compactAddons = (group) => {
    const pairs = group.map((field) => [...field.querySelectorAll('input[type="radio"]')]);
    if (pairs.some((radios) => radios.length !== 2)) return;
    group.forEach((field, i) => {
      field.classList.add('hp-addon--compact');
      field.classList.toggle('hp-addon--last', i === 0);
    });
    let list = group[0].querySelector('.hp-addon-list');
    if (!list) {
      const label = (radio) => (radio.closest('.tee-radio')?.querySelector('label')?.textContent || '').replace(/\s+/g, ' ').trim();
      const rows = group.map((field, i) => {
        const [no, yes] = pairs[i];
        // The yes label carries the price, sometimes twice: "+249 kr" from its text and "+249 SEK" added by Teeinblue.
        const yesText = label(yes);
        const kronor = Number((yesText.match(/\+\s*(\d+)\s*(?:kr|SEK)\b/i) || [])[1]) || 0;
        const price = kronor ? `+${kronor} kr` : '';
        const name = yesText
          .replace(/\+\s*\d+\s*(?:kr|SEK)\b/gi, '')
          .replace(/^ja,?\s*/i, '')
          .replace(/\s+/g, ' ')
          .trim();
        const noText = label(no);
        const hint =
          (field.querySelector('.tee-input-hint')?.textContent || '').replace(/\s*\+\s*\d+\s*(?:kr|SEK)\.?\s*$/i, '').trim() ||
          (/^nej\b/i.test(noText) ? '' : `I stället för ${noText.charAt(0).toLowerCase()}${noText.slice(1)}`);
        const row = document.createElement('label');
        row.className = 'hp-addon-row';
        row.dataset.lead = String(Boolean(leadHeading) && heading(field).startsWith(leadHeading));
        row.innerHTML =
          '<input type="checkbox" class="hp-addon-row__box" data-bag-ignore><span class="hp-addon-row__text"><span class="hp-addon-row__name"></span><span class="hp-addon-row__hint"></span></span><span class="hp-addon-row__price"></span>';
        row.querySelector('.hp-addon-row__name').textContent = name.charAt(0).toUpperCase() + name.slice(1);
        row.querySelector('.hp-addon-row__hint').textContent = hint;
        row.querySelector('.hp-addon-row__price').textContent = price;
        row.hpKronor = kronor;
        // Teeinblue reacts to a click on the option's label, not to a click on the radio itself.
        row.querySelector('input').addEventListener('change', (event) => {
          const target = event.target.checked ? yes : no;
          if (!radioOn(target)) (target.closest('.tee-radio')?.querySelector('label') || target).click();
        });
        row.hpRadios = { no, yes };
        return row;
      });
      rows.sort((a, b) => (b.dataset.lead === 'true') - (a.dataset.lead === 'true'));
      list = document.createElement('div');
      list.className = 'hp-addon-list';
      list.append(...rows);
      group[0].prepend(list);
    }
    // Teeinblue may restore earlier choices or re-render, so the boxes always follow its radios.
    let extra = 0;
    list.querySelectorAll('.hp-addon-row').forEach((row) => {
      const box = row.querySelector('input');
      const { yes } = row.hpRadios;
      if (!yes.isConnected) {
        list.remove();
        return;
      }
      box.checked = Boolean(radioOn(yes));
      if (box.checked) extra += row.hpKronor;
    });
    // The buy button ("Lägg i varukorgen · 379 kr") shows the price with the ticked add-ons, as the cart will.
    const base = parseInt(document.querySelector('meta[property="og:price:amount"]')?.content || '', 10);
    const buyText = document.querySelector('.product-form__submit:not([disabled]) > span');
    const wanted = buyText && base ? buyText.textContent.replace(/·\s*[\d\s]+kr\s*$/, `· ${base + extra} kr`) : '';
    if (wanted && buyText.textContent !== wanted) buyText.textContent = wanted;
  };
  const groupAddons = (fields) => {
    const start = fields.findIndex((field) => addonsHeading && heading(field).startsWith(addonsHeading));
    if (start < 0) return;
    const group = [];
    for (let i = start; i < fields.length && fields[i].querySelector('input[type="radio"]'); i += 1) group.push(fields[i]);
    if (!fields[start].classList.contains('hp-addon')) {
      group.forEach((field, i) => {
        field.classList.add('hp-addon');
        field.classList.toggle('hp-addon--first', i === 0);
        field.classList.toggle('hp-addon--last', i === group.length - 1);
      });
      if (group.length && guide.dataset.addonsTitle) group[0].dataset.hpAddonsTitle = guide.dataset.addonsTitle;
    }
    if (group.length && guide.dataset.addonsCompact === 'true') compactAddons(group);
  };
  const apply = () => {
    const form = document.querySelector('#teeFormInputs');
    if (!form) return;
    const fields = [...form.querySelectorAll('.tee-field')];
    const story =
      fields.find((field) => storyHeading && heading(field).startsWith(storyHeading) && field.querySelector('textarea')) ||
      fields.find((field) => field.querySelector('textarea'));
    if (story) addChips(story);
    groupAddons(fields);
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    setTimeout(() => {
      pending = false;
      apply();
    }, 120);
  };
  apply();
  // Class changes too: Teeinblue marks the chosen radio with "active", which the compact add-on boxes follow.
  new MutationObserver(schedule).observe(document.querySelector('product-info') || document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
})();

// Play button on the product image (hp_audio setting image_button): sample 1 can be heard before scrolling. The button
// drives the first player below (one sample plays at a time) and shows the sample's name while it plays.
(() => {
  const audioBlock = document.querySelector('[data-hp-listen]');
  const wrapper = document.querySelector('.product__media-wrapper');
  const first = audioBlock && audioBlock.querySelector('[data-hp-audio]');
  if (!first || !wrapper) return;
  const audio = first.querySelector('audio');
  const play = first.querySelector('.hp-audio__play');
  const title = first.querySelector('.hp-audio__title')?.textContent.trim() || '';
  const layer = document.createElement('div');
  layer.className = 'hp-listen-layer';
  layer.innerHTML =
    '<button type="button" class="hp-listen" aria-pressed="false"><span class="hp-listen__icon" aria-hidden="true"></span><span class="hp-listen__text"></span><span class="hp-listen__bars" aria-hidden="true"><span></span><span></span><span></span></span></button>';
  const button = layer.querySelector('.hp-listen');
  const text = layer.querySelector('.hp-listen__text');
  const render = () => {
    const playing = !audio.paused && !audio.ended;
    button.classList.toggle('is-playing', playing);
    button.setAttribute('aria-pressed', String(playing));
    text.textContent = playing ? title : audioBlock.dataset.hpListen;
    button.setAttribute('aria-label', text.textContent);
  };
  button.addEventListener('click', () => play.click());
  ['play', 'pause', 'ended'].forEach((type) => audio.addEventListener(type, render));
  render();
  wrapper.classList.add('hp-has-listen');
  wrapper.prepend(layer);
  // On the other pictures the button shrinks to a round icon in the corner so the product images stay visible.
  const compact = () => {
    const slides = [...wrapper.querySelectorAll('.tee-slide')];
    const index = slides.findIndex((slide) => slide.classList.contains('tee-slide--active'));
    layer.classList.toggle('is-compact', index > 0);
  };
  compact();
  new MutationObserver(compact).observe(wrapper, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();

// Template gallery (snippets/hp-gallery.liquid): thumbnails scroll the track; the current slide marks its thumbnail.
(() => {
  document.querySelectorAll('[data-hp-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-hp-gallery-track]');
    const thumbs = [...gallery.querySelectorAll('[data-hp-gallery-thumb]')];
    const mark = () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
    };
    thumbs.forEach((thumb, i) =>
      thumb.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }))
    );
    track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
    mark();
  });
})();

// Song pages: the form header (a store-wide Teeinblue text) becomes "Skapa er låt" or "Skapa pappas låt" between
// notes. Teeinblue re-renders it, so the text is re-applied whenever it changes. The sticky button is in the buy bars
// block above; colours live in hp-product.css.
(() => {
  const songWords = document.querySelector('.hp-scope--song')
    ? 'Skapa er låt'
    : document.querySelector('.hp-scope--pappa')
      ? 'Skapa pappas låt'
      : '';
  if (!songWords) return;
  const formTitle = `🎵 ${songWords} 🎵`;
  const apply = () => {
    document.querySelectorAll('.tee-form-header__title').forEach((title) => {
      if (title.textContent !== formTitle) title.textContent = formTitle;
    });
  };
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true, characterData: true });
  apply();
})();

// Song page: the two optional fields ("Vem ger låten?" and "Uttal …") start folded under "Fler detaljer (valfritt)",
// so the required questions and the buy button come sooner. One tap opens them for good.
(() => {
  if (!document.querySelector('.hp-scope--song')) return;
  const optional = ['.tee-field--layer-252738', '.tee-field--layer-736128'];
  let open = false;
  const place = () => {
    const form = document.querySelector('#teeFormInputs');
    const first = form && form.querySelector(optional[0]);
    if (!form || !first) return;
    form.classList.toggle('hp-fold-closed', !open);
    if (open || form.querySelector('.hp-fold-toggle')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'hp-fold-toggle';
    button.textContent = '+ Fler detaljer (valfritt)';
    button.addEventListener('click', () => {
      open = true;
      form.classList.remove('hp-fold-closed');
      button.remove();
      first.querySelector('input, textarea')?.focus();
    });
    first.before(button);
  };
  new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
  place();
})();
